var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navigation-scroll-arrows',[_c('div',{staticClass:"flex",class:_vm.$style.list},_vm._l((_vm.items),function(item,idx){return _c('navigation-link',{key:idx,class:_vm.$style.listItem,attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }